var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Primary",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_821",
    "data-name": "Rectangle 821",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "diversity_3_FILL0_wght400_GRAD0_opsz48",
    d: "M2,22.545V18.909a1.591,1.591,0,0,1,1.591-1.591H6.8a1.515,1.515,0,0,1,.739.193,1.838,1.838,0,0,1,.6.534,4.51,4.51,0,0,0,1.682,1.477,4.768,4.768,0,0,0,6.068-1.477,1.88,1.88,0,0,1,.591-.534,1.452,1.452,0,0,1,.727-.193h3.2A1.591,1.591,0,0,1,22,18.909v3.636H16.091v-2.7A5.9,5.9,0,0,1,14.216,21,6.085,6.085,0,0,1,12,21.409,6,6,0,0,1,9.8,21a6.215,6.215,0,0,1-1.886-1.159v2.7Zm10-3.864a3.348,3.348,0,0,1-1.534-.375,3.16,3.16,0,0,1-1.193-1.034,2.978,2.978,0,0,0-.875-.841A3.22,3.22,0,0,0,7.3,16a4.339,4.339,0,0,1,2.068-1.045A10.581,10.581,0,0,1,12,14.591a10.714,10.714,0,0,1,2.648.364A4.348,4.348,0,0,1,16.727,16a3.22,3.22,0,0,0-1.1.432,2.978,2.978,0,0,0-.875.841,3.16,3.16,0,0,1-1.193,1.034A3.394,3.394,0,0,1,12,18.682ZM4.727,15.727a2.4,2.4,0,0,1-1.761-.739,2.483,2.483,0,0,1,0-3.534,2.423,2.423,0,0,1,1.761-.727A2.5,2.5,0,0,1,6.5,14.989,2.394,2.394,0,0,1,4.727,15.727Zm14.545,0a2.522,2.522,0,0,1-2.5-2.5,2.394,2.394,0,0,1,.739-1.773,2.5,2.5,0,0,1,3.534,3.534A2.394,2.394,0,0,1,19.273,15.727ZM12,13a2.522,2.522,0,0,1-2.5-2.5,2.394,2.394,0,0,1,.739-1.773A2.494,2.494,0,0,1,14.5,10.5a2.423,2.423,0,0,1-.727,1.761A2.394,2.394,0,0,1,12,13Z",
    transform: "translate(0 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/Members.5984f19c.svg";
export { ForwardRef as ReactComponent };